// Parses into a div of a detached document: unlike a div from `document`, it runs no handlers (e.g. <img onerror>) and loads nothing.
export const parseHtmlInert = (html?: string | null): HTMLElement => {
  const div = document.implementation.createHTMLDocument('').createElement('div');
  div.innerHTML = html ?? '';
  return div;
};
